import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import BaseFormLayout from 'Components/ComponentLibrary/Templates/Unauthenticated/Content/BaseFormLayout';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import { useFooterContext } from 'Context/FooterContext';
import { useSetNewPasswordContext } from '../../../SetNewPasswordContext';

const SetNewPassword = () => {
  const { handleSubmit } = useSetNewPasswordContext();
  const { footerRef } = useFooterContext();
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();

  const setNewPassword = async event => {
    if (event) {
      event.preventDefault();
    }
    const coll = await onSubmit();
    if (coll) {
      handleSubmit(coll);
    }
  };

  return (
    <BaseFormLayout
      onSubmit={setNewPassword}
      id={'multi-factor-authentication-form'}
      title={'Password Reset'}
      errors={unsourcedErrors}
      message={resource.attr('message')}
    >
      <MetaField
        attr={'password'}
      />

      <Portal container={footerRef.current}>
        <RoundedButton
          test={'authentication-set-new-password-login-button'}
          type={'submit'}
          onClick={setNewPassword}
          fullWidth
        >
          {'Login'}
        </RoundedButton>
      </Portal>
    </BaseFormLayout>
  );
};

export default SetNewPassword;
